import { render, staticRenderFns } from "./batchAddFiles.vue?vue&type=template&id=6296a3a8&scoped=true&"
import script from "./batchAddFiles.vue?vue&type=script&lang=js&"
export * from "./batchAddFiles.vue?vue&type=script&lang=js&"
import style0 from "./batchAddFiles.vue?vue&type=style&index=0&id=6296a3a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6296a3a8",
  null
  
)

export default component.exports